<tui-root [attr.tuiTheme]="darkMode() ? 'dark' : null">
  <router-outlet />

  <router-outlet name="modal" />
</tui-root>
